import React, { useState } from 'react';
import { message, Spin } from 'antd';
import { ArchiveFilledIcon, ArchiveIcon, SecondNoteIcon, TestEyeIcon, TestStartIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setContinue } from 'modules/auth';
import { ITestProps, TestModal } from 'modules/mavzuli-test';
import { useSaveTest } from 'modules/saved-tests';

import { Visible } from 'components';

const TestCard = ({
  subjectName,
  lessonName,
  testCount,
  testRating,
  viewCount,
  isSaved,
  testId,
  testUrl
}: ITestProps) => {
  const t = useTranslations();
  const { push } = useRouter();
  const [open, setOpen] = useState<boolean>(false);
  const [testInfo, setTestInfo] = useState<ITestProps>();
  const [isSavedState, setIsSavedState] = useState<boolean>(isSaved);
  const user = useAppSelector(state => state.user);
  const dispatch = useAppDispatch();

  const saveTest = useSaveTest();

  const handleSaveTest = (newStatus: boolean) => {
    if (testId == null) return;
    if (user.phone) {
      saveTest.mutate(
        { id: testId, status: newStatus },
        {
          onSuccess: () => {
            setIsSavedState(newStatus);
            message.success(t('Muvaffaqiyatli_bajarildi'));
          }
        }
      );
    } else {
      push('/login');
      dispatch(setContinue());
    }
  };

  return (
    <div>
      <div
        onClick={() => {
          setOpen(true);
          setTestInfo({
            subjectName,
            lessonName,
            testCount,
            testRating,
            viewCount,
            isSaved,
            testId,
            testUrl
          });
        }}
        className="flex h-full cursor-pointer flex-col space-y-7 rounded-2xl bg-white p-4 shadow-md"
      >
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div className="rounded-md bg-gray-100 px-2 py-1 text-sm">{subjectName}</div>
            <div
              onClick={e => {
                e.stopPropagation();
                handleSaveTest(!isSavedState);
              }}
              className="cursor-pointer"
            >
              <Visible
                if={saveTest.isLoading}
                else={
                  <Visible if={isSavedState} else={<ArchiveIcon />}>
                    <ArchiveFilledIcon />
                  </Visible>
                }
              >
                <Spin size="small" />
              </Visible>
            </div>
          </div>
          <p className="mt-2 line-clamp-2 font-medium">{lessonName}</p>
        </div>

        <div className="flex items-end justify-between">
          <div className="flex items-center gap-1">
            <TestStartIcon />
            {testRating}
          </div>
          <div className="flex items-center gap-1">
            <SecondNoteIcon />
            {testCount} {t('test')}
          </div>
          <div className="flex items-center gap-1">
            <TestEyeIcon />
            {viewCount}
          </div>
        </div>
      </div>
      <TestModal open={open} onClose={() => setOpen(false)} selectedData={testInfo} />
    </div>
  );
};

export default TestCard;
